import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-my-center",
  "use": "icon-my-center-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-my-center\"><defs><style type=\"text/css\"></style></defs><path d=\"M788.8 288c0 153.6-123.2 276.8-276.8 276.8S235.2 441.6 235.2 288 358.4 12.8 512 12.8 788.8 134.4 788.8 288zM864 1012.8H136c-32 0-46.4-24-46.4-56 0-190.4 139.2-340.8 324.8-340.8h171.2c185.6 0 347.2 152 347.2 342.4v-3.2c1.6 32-36.8 56-68.8 57.6z\" fill=\"\" p-id=\"9786\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol